<template>
  <div class="register-form">
    <div class="rf-title">完善管理员信息</div>
    <Form
      ref="formInline"
      :model="formInline"
      :rules="ruleInline"
      label-position="right"
      :label-width="150"
      @submit.native.prevent
    >
      <FormItem label="管理员姓名：" prop="name">
        <Input type="text" v-model="formInline.name" placeholder="请输入姓名" />
      </FormItem>

      <FormItem label="管理员邮箱：" prop="email">
        <Input v-model="formInline.email" placeholder="请输入邮箱" />
      </FormItem>
      <FormItem label="邮箱验证码：" class="form-code-item" prop="captcha">
        <Row>
          <Col span="16">
            <Input type="text" v-model="formInline.captcha" placeholder="请填写验证码" />
          </Col>
          <Col span="8">
            <Button v-if="showCode" @click="getCaptcha">获取验证码</Button>
            <Button v-else disabled>{{count}}s后重新获取</Button>
          </Col>
        </Row>
      </FormItem>
      <!-- <FormItem label="绑定微信：">
          <img src="./img/code.jpg" width="100" height="100">
      </FormItem>-->
      <FormItem>
        <Button type="primary" size="large" @click="handleSubmit('formInline')" long>保存并登录</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "exhibition-register-admin",
  data() {
    return {
      timer: null,
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      formInline: {
        // form双向绑定
        name: "",
        email: "",
        captcha: ""
      },
      ruleInline: {
        name: [
          { required: true, message: "姓名不能为空", trigger: "blur" },
          {
            type: "string",
            min: 2,
            message: "姓名不能小于2位",
            trigger: "blur"
          },
          {
            type: "string",
            max: 50,
            message: "姓名不能大于50位",
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          { type: "email", message: "邮箱格式有误", trigger: "blur" }
        ],
        captcha: [
          { required: true, message: "验证码为必填选项", trigger: "blur" }
        ]
      }
    };
  },
  created() {},
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  methods: {
    ...mapActions({
      getStaffByCompId: "companyModule/getStaffByCompId",

      changeEmailToken: "companyModule/changeEmailToken", // （原邮箱不为空） 新邮箱发送验证码
      changeEmailOldToken: "companyModule/changeEmailOldToken", // （原邮箱不为空） 发送验证码
      changeEmailApply: "companyModule/changeEmailApply", // （原邮箱不为空） 验证并更改邮箱
      changeEmailOldCheck: "companyModule/changeEmailOldCheck", // （原邮箱不为空） 验证邮箱验证码（省略）

      bindEmailToken: "companyModule/bindEmailToken", // （原邮箱为空） 发送验证码
      bindEmailApply: "companyModule/bindEmailApply", // 验证并更改邮箱 绑定邮箱（原邮箱为空）

      bindEmailTokenCheck: "companyModule/bindEmailTokenCheck" // 验证邮箱
    }),
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.bindNewEmail(name);
        }
      });
    },
    getCaptcha() {
      this.$refs.formInline.validateField("email", val => {
        if (val !== "") return;
        this.downTime();
      });
    },
    async downTime(name) {
      let valid = null;
      // 绑定新邮箱
      valid = await this.bindEmailToken({
        UserId: this.user.id,
        NewEmail: this.formInline.email,
        IsEnglishEmail: false
      });
      if (!valid) {
        this.$Message.error("验证未通过,请重新尝试!");
        return false;
      }
      if (valid && !valid.successed && valid.msg) {
        this.$Message.error(valid.msg);
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code) {
          this.$Message.error(valid.errors[0].description);
        }
        return;
      }
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async bindNewEmail(name) {
      // 验证邮箱
      let valid = await this.bindEmailTokenCheck({
        UserId: this.user.id,
        NewEmail: this.formInline.email,
        token: this.formInline.captcha,
        IsEnglishEmail: false
      });
      if (!valid) {
        this.$Message.error("验证未通过,请重新尝试!");
        return false;
      }
      if (valid && !valid.successed && valid.msg) {
        this.$Message.error(valid.msg);
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code) {
          this.$Message.error(valid.errors[0].description);
        }
        return;
      }
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$emit("finish", this.formInline);
        }
      });
    }
  }
};
</script>

<style scoped lang='scss'>
.register-form {
  font-size: 14px;
  width: 600px;
  margin: 0 auto;
  .rf {
    &-title {
      font-size: 20px;
      color: #333;
      padding: 60px 0 44px;
      text-align: center;
    }
  }
  .form-code-item {
    .ivu-btn {
      margin-left: 10px;
      width: calc(100% - 10px);
    }
  }
  .form-tip-info {
    color: #1890ff;
    cursor: pointer;
  }
}
</style>